// removed by extract-text-webpack-plugin
module.exports = {"batch-sent-items-table":"BatchSentItemsTable__batch-sent-items-table___3ANKM"};